<div class="row g-4">
    <div class="col-12 col-xl-12">
      <mat-card>
        <mat-card-content>
          <h5 class="mb-3">Student form</h5>
          <div class="row g-3">
            <!-- Course Dropdown -->
            <div class="col-12 col-md-6">
              <mat-form-field class="w-100" appearance="fill">
                <mat-label>Course</mat-label>
                <mat-select [(ngModel)]="selectedCourseId" name="course" (selectionChange)="onFiltersChange()">
                  <mat-option *ngFor="let course of courseList" [value]="course.id">{{ course.name }}-{{course.crs_code}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
  
            <!-- Semester Dropdown -->
            <div class="col-12 col-md-6">
              <mat-form-field class="w-100" appearance="fill">
                <mat-label>Semester</mat-label>
                <mat-select [(ngModel)]="selectedSemesterId" name="semester" (selectionChange)="onFiltersChange()">
                  <mat-option *ngFor="let sem of semesterList" [value]="sem.number">{{ sem.name }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
  
            <!-- Submit -->
            <div class="col-12">
              <button (click)="delete_student_based_on_filters(selectedCourseId, selectedSemesterId)" mat-flat-button color="primary" [disabled]="isDeleteDisabled()">Delete</button>
            </div>

            <div class="search-wrapper">
              <mat-form-field appearance="outline" class="search-input">
                <mat-label>Search students</mat-label>
                <input
                  matInput
                  [(ngModel)]="searchText"
                  placeholder="Search by name, register no, email, or phone"
                />
              </mat-form-field>
            
              <button mat-flat-button color="primary" (click)="applyFilter()" class="search-btn">
                Search
              </button>
            </div>
            
            
            
            <button mat-flat-button color="primary" (click)="get_all_students_download()">
            Download Full List
          </button>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
</div>

<div *ngIf="student_list_visible">
  <mat-card>
    <mat-card-title class="title-center">Student List</mat-card-title>
  
    <div class="outer-scroll-wrapper">
      <div class="inner-scroll-container mat-elevation-z8">
        <table mat-table [dataSource]="students" class="full-width-table">
  
          <!-- Actions -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions </th>
            <td mat-cell *matCellDef="let student">
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon><b>⋮</b></mat-icon>
              </button>
          
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="onEdit(student)">
                  <mat-icon>edit</mat-icon>
                  <span>Edit</span>
                </button>
                <button mat-menu-item (click)="onDelete(student)">
                  <mat-icon>delete</mat-icon>
                  <span>Delete</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>
          
          
          
  
          <ng-container matColumnDef="sno">
            <th mat-header-cell *matHeaderCellDef> S.No. </th>
            <td mat-cell *matCellDef="let row; let i = index">
              {{ currentPage + i + 1 }}
            </td>
          </ng-container>
  
          <!-- Define columns -->
          <ng-container matColumnDef="course-name">
            <th mat-header-cell *matHeaderCellDef> course </th>
            <td mat-cell *matCellDef="let s"> {{ s.course.name }} </td>
          </ng-container>

          <ng-container matColumnDef="student_id">
            <th mat-header-cell *matHeaderCellDef> Student ID </th>
            <td mat-cell *matCellDef="let s"> {{ s.student_id }} </td>
          </ng-container>
  
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Name </th>
            <td mat-cell *matCellDef="let s"> {{ s.name }} </td>
          </ng-container>
  
          <ng-container matColumnDef="father_name">
            <th mat-header-cell *matHeaderCellDef> Father Name </th>
            <td mat-cell *matCellDef="let s"> {{ s.father_name }} </td>
          </ng-container>
  
          <ng-container matColumnDef="mother_name">
            <th mat-header-cell *matHeaderCellDef> Mother Name </th>
            <td mat-cell *matCellDef="let s"> {{ s.mother_name }} </td>
          </ng-container>
  
          <ng-container matColumnDef="register_no">
            <th mat-header-cell *matHeaderCellDef> Register No </th>
            <td mat-cell *matCellDef="let s"> {{ s.register_no }} </td>
          </ng-container>
  
          <ng-container matColumnDef="scheme_type">
            <th mat-header-cell *matHeaderCellDef> Scheme </th>
            <td mat-cell *matCellDef="let s"> {{ s.scheme_type }} </td>
          </ng-container>
  
          <ng-container matColumnDef="section">
            <th mat-header-cell *matHeaderCellDef> Section </th>
            <td mat-cell *matCellDef="let s"> {{ s.section }} </td>
          </ng-container>
  
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef> Email </th>
            <td mat-cell *matCellDef="let s"> {{ s.email }} </td>
          </ng-container>
  
          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef> Phone </th>
            <td mat-cell *matCellDef="let s"> {{ s.phone }} </td>
          </ng-container>
  
          <ng-container matColumnDef="gender">
            <th mat-header-cell *matHeaderCellDef> Gender </th>
            <td mat-cell *matCellDef="let s"> {{ s.gender || '-' }} </td>
          </ng-container>
  
          <ng-container matColumnDef="dob">
            <th mat-header-cell *matHeaderCellDef> DOB </th>
            <td mat-cell *matCellDef="let s"> {{ s.dob }} </td>
          </ng-container>
  
          <!-- Header and Row -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
    <mat-paginator
              [pageSizeOptions]="[5, 10, 15, 20]"
              [length]="pagination.length"
              [pageIndex]="pagination.page - 1"
              [pageSize]="pagination.limit"
              (page)="pageEvent($event)"
              *ngIf="pagination.length">
  </mat-paginator>
  </mat-card>
</div>

<div *ngIf="edit_form">
  <div class="container-fluid">
    <div class="row g-4">
      <div class="col-12">
        <mat-card>
          <mat-card-content>
           
           <div>
            <form [formGroup]="formGroup">             
              <!-- Contact Information Section -->
              <div lass="row g-4 mt-3">
                <div class="col-12">
                  <h6 class="section-title">Courseformation</h6>
                </div>
  
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>enter name :</mat-label>
                    <input matInput formControlName="name" placeholder="Enter name" type="text">
                  </mat-form-field>
                </div>
                
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>father_name :</mat-label>
                    <input matInput formControlName="father_name" placeholder="Enter father_name " type="text">
                  </mat-form-field>
                </div>
  
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>mother_name :</mat-label>
                    <input matInput formControlName="mother_name" placeholder="Enter mother_name " type="text">
                  </mat-form-field>
                </div>
                
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>register_no :</mat-label>
                    <input matInput formControlName="register_no" placeholder="Enter register_no " type="text">
                  </mat-form-field>
                </div>
  
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>scheme :</mat-label>
                    <input matInput formControlName="scheme_type" placeholder="Enter scheme " type="text">
                  </mat-form-field>
                </div>
  
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>section :</mat-label>
                    <input matInput formControlName="section" placeholder="Enter section " type="text">
                  </mat-form-field>
                </div>
  
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>email :</mat-label>
                    <input matInput formControlName="email" placeholder="Enter email " type="text">
                  </mat-form-field>
                </div>
  
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>phone :</mat-label>
                    <input matInput formControlName="phone" placeholder="Enter phone " type="text">
                  </mat-form-field>
                </div>
  
                <!-- <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>gender :</mat-label>
                    <input matInput formControlName="gender" placeholder="Enter gender " type="text">
                  </mat-form-field>
                </div> -->

                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Gender</mat-label>
                    <mat-select formControlName="gender">
                      <mat-option value="male">Male</mat-option>
                      <mat-option value="female">Female</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>course name :</mat-label>
                    <input matInput formControlName="course_name" placeholder="Enter course_name " type="text">
                  </mat-form-field>
                </div> -->

                <div *ngIf="role === 'admin'" class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Course Name</mat-label>
                    <mat-select formControlName="course_id">
                      <mat-option *ngFor="let course of courseList" [value]="course.id">
                        {{ course.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- <div class="col-12 col-md-6">
                  <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Course</mat-label>
                    <mat-select [(ngModel)]="selectedCourseId" name="course">
                      <mat-option formControlName="course_name" placeholder="Enter course_name " *ngFor="let course of courseList" [value]="course.id">{{ course.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div> -->
  
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>dob :</mat-label>
                    <input matInput formControlName="dob" placeholder="Enter dob " type="text">
                  </mat-form-field>
                </div>
                
              </div>
              
  
              <div class="row mt-4">
                <div class="col-12">
                  <div class="d-flex gap-3">
                    <button mat-flat-button color="primary" [disabled]="isLoading " (click)="edit_student()" class="px-4 py-2">
                      {{ isEdit ? 'Update' : 'Save' }}
                    </button>
                    <button mat-stroked-button [disabled]="isLoading" (click)="resetForm()" class="px-4 py-2">
                      RESET
                    </button>
  
                    <button *ngIf="isEdit || !isCourseList" mat-flat-button color="primary"  (click)="back()" class="px-4 py-2">
                      Back
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    </div>
  </div>
</div>






  
  